import React from "react";
import { Text, View, Image } from "@react-pdf/renderer";
import PrintApplicationStyles from "../PrintApplicationStyles";

import { formatPrintDate } from "../formatPrintDate";

const PrintSection11 = ({ section11 }) => {
  return (
    <>
      <Text break style={PrintApplicationStyles.sectionheader}>
        Section 11 – Declaration and Consent
      </Text>

      {/* OLD STRUCTURE SUPPORT */}
      {section11?.confirmedDeclaration !== undefined && (
        <>
          <Text style={PrintApplicationStyles.subcontent}>
            Important: Please read carefully before completing
          </Text>
          <Text style={PrintApplicationStyles.content}>
            I confirm that I have read and understood this application form and
            the information provided herein is true and complete to the best of
            my knowledge and belief. I understand that any deliberate omission
            of relevant information or submission of false information may
            result in my application being rejected or, if I am appointed, may
            result in my immediate dismissal.
          </Text>
          <Text style={PrintApplicationStyles.content}>
            I consent to the organisation making whatever enquiries it considers
            appropriate to verify the information I have provided in this
            application, including:
          </Text>
          <View style={PrintApplicationStyles.tableRow}>
            <View style={PrintApplicationStyles.inputSection}>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  • References from previous employers or educational
                  institutions
                </Text>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  • Enhanced DBS (Disclosure Barring Service) and/or CRB
                  (Criminal Records Bureau) checks
                </Text>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  • Verification of qualifications and professional credentials
                </Text>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  • Right to work in the United Kingdom checks
                </Text>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  • Occupational health assessments
                </Text>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  • Credit and financial history checks (where relevant to the
                  role)
                </Text>
              </View>
            </View>
          </View>
          <Text style={PrintApplicationStyles.content}>
            I acknowledge that I have been informed of my rights and
            responsibilities under the Data Protection Act 2018 and UK GDPR, and
            I consent to the processing of my personal data for recruitment,
            employment, and compliance purposes.
          </Text>
          <Text style={PrintApplicationStyles.content}>
            I confirm that I am legally entitled to work in the United Kingdom
            and I will provide evidence of this upon request.
          </Text>

          <Text  style={PrintApplicationStyles.subcontent}>
            Declaration by Candidate
          </Text>
          <View style={PrintApplicationStyles.tableRow}>
            <View style={PrintApplicationStyles.inputSection}>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  I confirm that I have read and understood the declaration
                  above and that the information I have provided in this
                  application is accurate and complete:
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>
                    {section11?.confirmedDeclaration === true
                      ? "Yes"
                      : section11?.confirmedDeclaration === false
                        ? "No"
                        : ""}
                  </Text>
                </View>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  Candidate's Full Name
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>{section11?.candidateName || ""}</Text>
                </View>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>Signature</Text>
                <View style={PrintApplicationStyles.inputBox}>
                  {section11?.candidateSignature ? (
                    <Image
                      src={section11.candidateSignature}
                      style={{
                        width: 200,
                        height: 80,
                        marginTop: 10,
                      }}
                    />
                  ) : (
                    <Text></Text>
                  )}
                </View>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>Date</Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>
                    {formatPrintDate(section11?.date)}
                  </Text>
                </View>
              </View>
            </View>
          </View>

          <Text  style={PrintApplicationStyles.subcontent}>
            Authorization by Employer or Representative (if applicable)
          </Text>
          <View style={PrintApplicationStyles.tableRow}>
            <View style={PrintApplicationStyles.inputSection}>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  If this application is being submitted on behalf of the
                  candidate by an employer or authorized representative, please
                  confirm:
                </Text>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  Representative's Full Name
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>{section11?.representativeName || ""}</Text>
                </View>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  Representative's Title/Position
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>{section11?.representativeTitle || ""}</Text>
                </View>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  Organization Name
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>{section11?.representativeOrganization || ""}</Text>
                </View>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>Signature</Text>
                <View style={PrintApplicationStyles.inputBox}>
                  {section11?.representativeSignature ? (
                    <Image
                      src={section11.representativeSignature}
                      style={{
                        width: 200,
                        height: 80,
                        marginTop: 10,
                      }}
                    />
                  ) : (
                    <Text></Text>
                  )}
                </View>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>Date</Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>
                    {formatPrintDate(section11?.representativeDate)}
                  </Text>
                </View>
              </View>
            </View>
          </View>

          <Text style={PrintApplicationStyles.content}>
            Please note: We will require your actual signature on this
            declaration and not an e-signature. Typed or digital initials or
            electronic signatures may not be acceptable.
          </Text>
          <Text style={PrintApplicationStyles.content}>
            For Data Protection enquiries or to exercise your rights, please
            contact the organisation's Data Protection Officer or privacy team.
          </Text>
        </>
      )}

      {/* NEW STRUCTURE SUPPORT */}
      {section11?.fullname !== undefined && (
        <>
          <Text  style={PrintApplicationStyles.subcontent}>
            11.01 Reference Consent
          </Text>
          <Text style={PrintApplicationStyles.content}>
            My signature below authorises my former employers and referees to
            release information regarding my employment record with Rosemount
            Financial Solutions (IFA) Ltd and to provide any additional
            information that may be necessary for my application for employment
            with them.
          </Text>
          <Text style={PrintApplicationStyles.content}>
            I understand and acknowledge that any offer of appointment is
            conditional to Rosemount Financial Solutions (IFA) Ltd being
            completely satisfied with the information provided by these
            references.
          </Text>

          <Text style={PrintApplicationStyles.subcontent}>
            11.01.1 Print Name Authorization
          </Text>
          <View style={PrintApplicationStyles.tableRow}>
            <View style={PrintApplicationStyles.inputSection}>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  Print Name
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>{section11?.printName || ""}</Text>
                </View>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>Signature</Text>
                <View style={PrintApplicationStyles.inputBox}>
                  {section11?.printNameSignature ? (
                    <Image
                      src={section11.printNameSignature}
                      style={{
                        width: 200,
                        height: 80,
                        marginTop: 10,
                      }}
                    />
                  ) : (
                    <Text>Not provided</Text>
                  )}
                </View>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>Date</Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>
                    {formatPrintDate(section11?.printNameDate)}
                  </Text>
                </View>
              </View>
            </View>
          </View>

          <Text  style={PrintApplicationStyles.subcontent}>
            11.02 Important Information
          </Text>
          <Text style={PrintApplicationStyles.content}>
            It may be a criminal offence to provide false or misleading
            information to the Financial Conduct Authority or Rosemount
            Financial Solutions (IFA) Ltd. It is, therefore, vital that all
            questions in this application form have been answered fully and
            accurately.
          </Text>
          <Text style={PrintApplicationStyles.content}>
            I understand that any information contained in the application or
            otherwise supplied by me/us may be shared with Rosemount Financial
            Solutions (IFA) Ltd for the purposes of processing this application
            and the Appointed Representative (if applicable) I am joining.
          </Text>

          <Text style={PrintApplicationStyles.subcontent}>
            11.03 Declaration of Application
          </Text>
          <Text style={PrintApplicationStyles.content}>
            I accept the terms and conditions of this application to join
            Rosemount Financial Solutions (IFA) Ltd.
          </Text>

          <View style={PrintApplicationStyles.tableRow}>
            <View style={PrintApplicationStyles.inputSection}>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  Full Name of Person Submitting the Application
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>{section11?.fullname || ""}</Text>
                </View>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>Signature</Text>
                <View style={PrintApplicationStyles.inputBox}>
                  {section11?.candidateSignature ? (
                    <Image
                      src={section11.candidateSignature}
                      style={{
                        width: 200,
                        height: 80,
                        marginTop: 10,
                      }}
                    />
                  ) : (
                    <Text></Text>
                  )}
                </View>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>Date</Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>
                    {formatPrintDate(section11?.date)}
                  </Text>
                </View>
              </View>
            </View>
          </View>

          <Text style={PrintApplicationStyles.content}>
            Please note - If you add an e-signature we will require a copy of
            the document with your actual signature on it.
          </Text>
        </>
      )}
    </>
  );
};

export default PrintSection11;
